import { LocalizationManager } from "../../localization/localization_manager.js";
import { GlobalSettings } from "../../global_settings.js";

export class FeedbackApiController
{
  static async sendSupportRequest( name: string, email: string, message: string ): Promise<{ success: boolean; error_key?: string }>
  {
    try
    {
      const response = await fetch( `${GlobalSettings.SUPPORT_BASE_URL}/webhook/support`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify( {
          name,
          email,
          text: message,
          language: LocalizationManager.getCurrentLanguage(),
          project: "royalsmash",
          env: GlobalSettings.ENV,
        } )
      } );

      if ( response.ok )
        return { success: true };

      switch ( response.status )
      {
        case 401: return { success: false, error_key: "FEEDBACK_SCREEN.AUTH_ERROR" };
        case 400: return { success: false, error_key: "FEEDBACK_SCREEN.VALIDATION_ERROR" };
        case 429: return { success: false, error_key: "FEEDBACK_SCREEN.RATE_LIMIT_ERROR" };
        case 503: return { success: false, error_key: "FEEDBACK_SCREEN.SERVER_ERROR" };
        default:  return { success: false, error_key: "FEEDBACK_SCREEN.SEND_ERROR" };
      }
    }
    catch ( error )
    {
      console.error( "Support request failed:", error );
      return { success: false, error_key: "FEEDBACK_SCREEN.NETWORK_ERROR" };
    }
  }
}
